"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compose = compose;
exports.default = void 0;

const identity = x => x;

function compose(...fns) {
  if (!fns.length) fns = [identity];
  return fns.reduce((f, g) => x => f(g(x)));
}

var _default = compose;
exports.default = _default;